import styled from 'styled-components'
import { StyledPreviewTextProps } from './TextStyleDropdown.types'

export const StyledTextStyleOption = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  width: 100%;
`

export const StyledPreviewText = styled.span<StyledPreviewTextProps>`
  font-size: ${({ $fontSize }) => $fontSize};
  font-weight: ${({ $fontWeight }) => $fontWeight};
  line-height: ${({ $lineHeight }) => $lineHeight};
  color: ${({ theme }) => theme.colors.text.primary};
  flex: 1;
`

export const StyledStyleLabel = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  color: ${({ theme }) => theme.colors.text.tertiary};
  margin-left: auto;
`
